$(document).on("metaslug_sinhnhat1tuoi_footer rendered", {}, function (event, uniqueId) {
  var $this = $("#" + uniqueId);
  $(".openMenu").on("click", function () {
    $(".nav-mobile_content").toggleClass("active");
    $(".openMenu").toggleClass("active");
  });
  // console.log(event);
  // console.log(uniqueId);
});